
import {
  Injectable,
  Injector,
  ComponentFactoryResolver,
  EmbeddedViewRef,
  ApplicationRef
} from '@angular/core';
import { ToasterComponent } from './toaster.component';
import { TosterData, TosterOption } from './toaster.interface';

@Injectable({
  providedIn: 'root'
})
export class ToasterService {

  constructor(private componentFactoryResolver: ComponentFactoryResolver,
    private appRef: ApplicationRef,
    private injector: Injector) { }

    show(data: TosterData, options: TosterOption = { top: '8vh' }, afterClose = () => {}) {
      // create a component reference from the component 
      const componentRef = this.componentFactoryResolver
        .resolveComponentFactory(ToasterComponent)
        .create(this.injector);
      const autoCloseTime = data.autoCloseTime || 0;
      // pass data
      componentRef.instance.data = data;
      componentRef.instance.options = options;
      // open modal after miliseconds
      setTimeout(() => {
        componentRef.instance.isOpen = true;
      })
  
      // auto close modal after miliseconds
      if(autoCloseTime) {
        setTimeout(() => {
          componentRef.instance.isOpen = false;
          this.appRef.detachView(componentRef.hostView);
          afterClose();
          componentRef.destroy();
        }, autoCloseTime);
      }
  
      // close on click
      componentRef.instance.closeToaster.subscribe(val => {
        this.appRef.detachView(componentRef.hostView);
        afterClose();
        componentRef.destroy();
      });
      // Attach component to the appRef so that it's inside the ng component tree
      this.appRef.attachView(componentRef.hostView);
  
      // Get DOM element from component
      const domElem = (componentRef.hostView as EmbeddedViewRef<any>)
        .rootNodes[0] as HTMLElement;
  
      // Append DOM element to the body
      document.body.appendChild(domElem);
    }

}
